import React, { useEffect, useState } from 'react';

import {
  Backdrop,
  CircularProgress,
  Divider,
  Stack,
  Typography,
} from '@mui/material';

import EditDetailsModal from 'Components/Portfolios/EditDetailsModal';
import PortfolioItem from 'Components/Portfolios/PortfolioItem/PortfolioItem';
import { usePortfolioContext } from 'Components/Portfolios/context';
import ErrorMessage from 'Components/UI/ErrorMessage';

const PortfolioList = ({ viewCompanyId }) => {
  const [error, setError] = useState(null);
  const {
    portfolios,
    sites,
    fetchPortfoliosAndSites,
    requestTestsCoverageDataForPortfolioUpdate,
    isLoading,
  } = usePortfolioContext();

  useEffect(() => {
    fetchPortfoliosAndSites();
  }, [viewCompanyId]);

  const handleCloseError = () => {
    setError(null);
  };

  return (
    <Stack>
      <Backdrop
        open={isLoading}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      <Divider sx={{ borderColor: 'grey.300' }} />
      {!!error && (
        <ErrorMessage
          message={error}
          handleCloseErrorAlert={handleCloseError}
        />
      )}
      {Object.values(portfolios).map((portfolio) => (
        <PortfolioItem
          key={`p_${portfolio.portfolioid}`}
          portfolio={portfolio}
          portfolioSites={sites[portfolio.portfolioid]?.sites}
          portfolioTerritories={sites[portfolio.portfolioid]?.territories}
          portfolioRegions={sites[portfolio.portfolioid]?.regions}
          requestTestsCoverageDataForPortfolioUpdate={
            requestTestsCoverageDataForPortfolioUpdate
          }
        />
      ))}
      {!Object.keys(portfolios).length && (
        <Typography variant="h4" sx={{ textAlign: 'center' }}>
          Portfolio is empty
        </Typography>
      )}
      <EditDetailsModal />
    </Stack>
  );
};
export default PortfolioList;
